import { render, staticRenderFns } from "./checkdetails.vue?vue&type=template&id=4f30b1ec&scoped=true"
import script from "./checkdetails.vue?vue&type=script&lang=js"
export * from "./checkdetails.vue?vue&type=script&lang=js"
import style0 from "./checkdetails.vue?vue&type=style&index=0&id=4f30b1ec&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f30b1ec",
  null
  
)

export default component.exports